<template>
    <div>
      <baseFrame saveText="" :submitText="able?'提交':''" clearText="" @submit="submit">
        <div slot="content">
          <lk-card title="">
            <lk-form
            ref="form"
            label-position="right"
            :model="formData">
                <div>
                    <div class='mb8'>
                        <lk-button type="primary" @click="handleModal" v-if="able">选择批次</lk-button>
                    </div>
                    <lk-table border :data='formData.tableData' :columns='columns'>
                        <template slot-scope="{ row, index }" slot="goodsBatchNewNumber">
                            <lk-form-item
                                :prop="'tableData.' + index + '.goodsBatchNewNumber'"
                                :label-width="0"
                                :rules="goodsBatchNewNumberFormRules">
                                <lk-input :maxlength='35' class="supplier"
                                    @on-change="validFormItemGoodsBatchNewNumber($event, row, index)"
                                    v-model="row.goodsBatchNewNumber" placeholder="请输入">
                                </lk-input>
                            </lk-form-item>
                        </template>
                        <template slot-scope="{ row, index }" slot="goodsProductionNewDate">
                            <lk-form-item
                                :prop="'tableData.' + index + '.goodsProductionNewDate'"
                                :label-width="0"
                                :rules="goodsProductionNewDateFormRules">
                                <timeStampDatePicker v-model.trim="row.goodsProductionNewDate" @on-change="validFormItemGoodsProductionNewDate($event, row, index)" class="item"></timeStampDatePicker>
                            </lk-form-item>
                        </template>
                        <template slot-scope="{ row, index }" slot="goodsExpiryNewDate">
                            <lk-form-item
                                :prop="'tableData.' + index + '.goodsExpiryNewDate'"
                                :label-width="0"
                                :rules="goodsExpiryNewDateFormRules">
                                <timeStampDatePicker v-model.trim="row.goodsExpiryNewDate" @on-change="validFormItemGoodsExpiryNewDate($event, row, index)" class="item"></timeStampDatePicker>
                            </lk-form-item>
                        </template>
                    </lk-table>
                </div>
            </lk-form>
          </lk-card>
        </div>
      </baseFrame>
      <lk-modal
        v-model="modal"
        title="选择库存批次"
        :width="850"
        :mask-closable='false'
        @on-cancel="modalCancel"
        >
        <div>
            <div class="queryContainer">
                <div class="queryItem">
                    <goodsSearchItem v-model="queryParams.nameMix" clearable placeholder='支持商品编码、通用名、商品名'></goodsSearchItem>
                </div>
                <div class="queryItem">
                    <label>批次号:</label>
                    <lk-input class="item" v-model.trim="queryParams.batchSeq" :maxlength="50" clearable placeholder="请输入"></lk-input>
                </div>
                <div class="queryItem">
                    <label>验收时间：</label>
                    <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='queryParams.duration' />
                </div>
                <div class="queryItem" v-if="tempRoleType !== 2">
                    <label>门店名称:</label>
                    <storeListSelect class="item" v-model="queryParams.storeIdList" clearable placeholder="请输入"></storeListSelect>
                </div>
                <div class="queryItem">
                    <lk-button type="primary" class="mr8" @click="searchClick">查询</lk-button>
                    <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
                </div>
            </div>
          <lk-table class='mb8' :data='resultList' :columns='orderCol' border
            @on-select='addSelection'
            @on-select-all='addSelection'
            @on-select-all-cancel="handleTempCancelAll"
            @on-select-cancel="handleTempCancel"
          ></lk-table>
          <lk-page style='text-align: right' size="small" show-elevator show-sizer :total='queryParams.count'
            @on-change='handlePageChange'
            @on-page-size-change='handleSizeChange'
          ></lk-page>
        </div>
        <div class="modalFooter" slot="footer">
          <lk-button @click='handleCancelSelection'>取消</lk-button>
          <lk-button type='primary' @click='handleSelection'>确定</lk-button>
        </div>
      </lk-modal>
    </div>
  </template>
<script>
import utils from '../../libs/utils';
import baseFrame from '../../components/frame/BaseFrame.vue';
import finance from '../../services/finance';
import system from '../../services/system';
import toolsService from '../../services/tools';
import timeStampDatePicker from '../../components/timeStampDatePicker.vue';

export default {
  name: 'addInfoRevisal',
  components: {
    baseFrame,
    timeStampDatePicker,
  },
  computed: { },
  data() {
    const checkGoodsBatchNum = (rule, value, callback) => {
      if (this.beforeGoodsBatchNumber == value) {
        callback(new Error('修改后数据不能与修改前数据相同'));
      }
      callback();
    };
    const checkGoodsProductionDate = (rule, value, callback) => {
      if (value != undefined && utils.exchangeTime(this.beforeGoodsProductionDate) == utils.exchangeTime(value)) { // 不能相等
        callback(new Error('修改后数据不能与修改前数据相同'));
        return;
      }
      if (value == null) {
        callback();
      }
      if (this.newGoodsExpiryDate != '' && this.newGoodsExpiryDate * 1 > 0 && this.newGoodsExpiryDate != undefined) { // 大于有效期
        if (value * 1 >= this.newGoodsExpiryDate * 1) {
            callback(new Error('生产日期不能晚于有效期'));
        } else {
            callback();
        }
        return;
      }
      if (value * 1 >= this.beforeGoodsExpiryDate * 1) { // 大于有效期
        callback(new Error('生产日期不能晚于有效期'));
        return;
      }
      callback();
    };
    const checkGoodsExpiryDate = (rule, value, callback) => {
      if (value != undefined && utils.exchangeTime(this.beforeGoodsExpiryDate) == utils.exchangeTime(value)) {
        callback(new Error('修改后数据不能与修改前数据相同'));
        return;
      }
      if (value == null) {
        callback();
      }
      if (this.newGoodsProductionDate != '' && this.newGoodsProductionDate * 1 > 0 && this.newGoodsProductionDate != undefined) { // 小于有生产日期);
        if (value * 1 <= this.newGoodsProductionDate * 1) {
            callback(new Error('生产日期不能晚于有效期'));
        } else {
            callback();
        }
        return;
      }
      if (value * 1 <= this.beforeGoodsProductionDate * 1) { // 大于有效期
        callback(new Error('生产日期不能晚于有效期'));
        return;
      }
      callback();
    };
    return {
      tempRoleType: this.$store.state.user.roleType,
      beforeGoodsBatchNumber: '',
      beforeGoodsProductionDate: '',
      beforeGoodsExpiryDate: '',
      newGoodsProductionDate: '',
      newGoodsExpiryDate: '',
      columns: [
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '批次号', key: 'goodsBatchSeq', minWidth: 116 },
        { title: '原批号', key: 'goodsBatchNumber', minWidth: 116 },
        {
          title: '新批号', key: 'goodsBatchNewNumber', slot: 'goodsBatchNewNumber', minWidth: 230,
        },
        {
          title: '原生产日期',
          key: 'goodsProductionDate',
          width: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.goodsProductionDate)),
        },
        {
          title: '新生产日期', key: 'goodsProductionNewDate', slot: 'goodsProductionNewDate', minWidth: 230,
        },
        {
          title: '原有效期',
          key: 'goodsExpiryDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.goodsExpiryDate)),
        },
        {
          title: '新有效期', key: 'goodsExpiryNewDate', slot: 'goodsExpiryNewDate', minWidth: 230,
        },
        {
          title: '操作',
          key: 'code',
          type: 'operation',
          minWidth: 116,
          render: (h, { row, index }) => h('div', [
            this.able && row.verificationType !== 1 ? h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.formData.tableData.splice(index, 1);
                  if (this.formData.tableData.length === 0) {
                    this.formData.paymentUserName = '';
                    this.formData.paymentUserPhone = '';
                  }
                },
              },
            }, '删除') : null,
          ]),
        },
      ],
      surplusTotal: '', // 剩余预收款
      tempList: [],
      constContent1: '应收核销购药人信息不一致，请重新选择',
      constContent2: '收款购药人信息和应收款购药人信息不匹配，是否更新收款购药人信息？',
      resultList: [
        // { type: 'selection', width: 60 },
      ],
      proceedsTypes: [

      ],
      orderCol: [
        { type: 'selection', width: 60 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 116 },
        { title: '批次', key: 'goodsBatchSeq', minWidth: 116 },
        { title: '批准文号', key: 'approvalNumber', minWidth: 116 },
        {
            title: '入库时间',
            key: 'createTime',
            minWidth: 136,
            render: (h, params) => h('span', utils.exchangeTime(params.row.createTime)), 
        },
        {
            title: '生产日期',
            key: 'goodsProductionDate',
            minWidth: 136,
            render: (h, params) => h('span', utils.exchangeTime(params.row.goodsProductionDate))
        },
        {
            title: '有效期',
            key: 'goodsExpiryDate',
            minWidth: 136,
            render: (h, params) => h('span', utils.exchangeTime(params.row.goodsExpiryDate))
        },
      ],
      modal: false,
      queryParams: {
        page: 1,
        size: 10,
        nameMix: '',
        batchSeq: '',
        inspectionBeginTime: '',
        inspectionEndTime: '',
        storeIdList: [],
        count: 0,
      },

      formData: {
        tableData: [],
        proceedsTime: new Date().getTime(),
      },
      formRules: [
        { required: true, message: '请选择...' },
      ],
      goodsBatchNewNumberFormRules: [
        {
          required: false,
          message: '请输入',
        },
        { validator: checkGoodsBatchNum, trigger: 'blur' },
      ],
      goodsProductionNewDateFormRules: [
        { required: false, message: '请选择...' },
        { validator: checkGoodsProductionDate, trigger: 'blur' },
      ],
      goodsExpiryNewDateFormRules: [
        { required: false, message: '请选择...' },
        { validator: checkGoodsExpiryDate, trigger: 'blur' },
      ],
      able: true,
    };
  },
  methods: {
    validFormItemGoodsBatchNewNumber(value, item, index) {
      this.formData.tableData[index] = item;
      this.beforeGoodsBatchNumber = item.goodsBatchNumber;
      this.$nextTick(() => {
        if (value == item.goodsBatchNumber) { // 重新触发验证
          this.$refs.form.validateField(`tableData.${index}.goodsBatchNewNumber`);
        }
      });
    },
    validFormItemGoodsProductionNewDate(value, item, index) {
      this.formData.tableData[index] = item;
      this.beforeGoodsProductionDate = item.goodsProductionDate;
      if (item.goodsProductionNewDate * 1 > 0) {
        this.newGoodsProductionDate = item.goodsProductionNewDate;
      } else {
        this.newGoodsProductionDate = '';
      }
      this.beforeGoodsExpiryDate = item.goodsExpiryDate;
      if (item.goodsExpiryNewDate * 1 > 0) {
        this.newGoodsExpiryDate = item.goodsExpiryNewDate;
      } else {
        this.newGoodsExpiryDate = '';
      }
      this.$nextTick(() => {
        if (!utils.isEmpty(value)) { // 重新触发验证
          this.$refs.form.validateField(`tableData.${index}.goodsProductionNewDate`);
        }
        this.$refs.form.validateField(`tableData.${index}.goodsExpiryNewDate`);
      });
    },
    validFormItemGoodsExpiryNewDate(value, item, index) {
      this.formData.tableData[index] = item;
      this.beforeGoodsExpiryDate = item.goodsExpiryDate;
      if (item.goodsExpiryNewDate * 1 > 0) {
        this.newGoodsExpiryDate = item.goodsExpiryNewDate;
      } else {
        this.newGoodsExpiryDate = '';
      }
      this.beforeGoodsProductionDate = item.goodsProductionDate;
      if (item.goodsProductionNewDate * 1 > 0) {
        this.newGoodsProductionDate = item.goodsProductionNewDate;
      } else {
        this.newGoodsProductionDate = '';
      }
      this.$nextTick(() => {
        if (!utils.isEmpty(value)) { // 重新触发验证
          this.$refs.form.validateField(`tableData.${index}.goodsExpiryNewDate`);
        }
        this.$refs.form.validateField(`tableData.${index}.goodsProductionNewDate`);
      });
    },
    clearModalQuery() {
      this.queryParams = {
        page: 1,
        size: 10,
        nameMix: '',
        batchSeq: '',
        inspectionBeginTime: '',
        inspectionEndTime: '',
        storeIdList: [],
        count: 0,
      };
    },
    searchClick() {
      if (this.queryParams.duration != undefined && this.queryParams.duration.length == 2) {
        this.queryParams.inspectionBeginTime = this.queryParams.duration[0];
        this.queryParams.inspectionEndTime = this.queryParams.duration[1];
      } else {
        this.queryParams.inspectionBeginTime = '';
        this.queryParams.inspectionEndTime = '';
      }
      this.handlePageChange(1);
    },
    handleSelection() {
      if (this.tempList.length > 10) {
        this.$Message.error('一次修改数据不能超过10个批次');
        return;
      }
      this.formData.tableData = this.tempList;
      this.modal = false;
    },
    handleCancelSelection() {
      this.tempList = utils.deepClone(this.formData.tableData);
      this.modal = false;
      this.resultList = [];
    },
    // 判断选择数组中的购药人姓名和电话是否一致
    checkRepeatName(array) {
      if (array.length < 2) {
        return true;
      }
      return array.every(item => (item.relatePatientName == array[0].relatePatientName
          && item.relatePatientPhone == array[0].relatePatientPhone));
    },
    addSelection(selection, row) {
      const exsitCodeArr = this.tempList.map(item => item.id);
      const newSelection = selection.filter(item => !exsitCodeArr.includes(item.id));
      this.tempList = this.tempList.concat(newSelection);
    },
    handleTempCancel(selection, row) {
      this.tempList = this.tempList.filter(item => item.id != row.id);
    },
    handleTempCancelAll(selection) {
      const exsitCodeArr = this.resultList.map(item => item.id);
      this.tempList = this.tempList.filter(item => !exsitCodeArr.includes(item.id));
    },
    handleModal() {
      this.modal = true;
      this.tempList = utils.deepClone(this.formData.tableData);
      this.clearModalQuery();
      this.getOrders();
    },
    submit() {
      const list = [];
      let canPass = true;
      if (this.formData.tableData.length <=0 ) {
        this.$Message.error('提交内容不能为空');
      }
      this.formData.tableData.forEach((item) => {
        const tempModel = {};
        tempModel.goodsStoreId = item.goodsStoreId;
        tempModel.goodsBatchSeq = item.goodsBatchSeq;
        tempModel.storeId = item.storeId;
        if (item.goodsBatchNewNumber != undefined && item.goodsBatchNewNumber != '' && item.goodsBatchNewNumber != null) {
          tempModel.goodsBatchNumber = item.goodsBatchNewNumber;
        }
        if (item.goodsProductionNewDate != undefined && item.goodsProductionNewDate != '' && item.goodsProductionNewDate != null) {
          tempModel.goodsProductionDate = item.goodsProductionNewDate;
        }
        if (item.goodsExpiryNewDate != undefined && item.goodsExpiryNewDate != '' && item.goodsExpiryNewDate != null) {
          tempModel.goodsExpiryDate = item.goodsExpiryNewDate;
        }
        const numberEmpty = item.goodsBatchNewNumber == undefined || item.goodsBatchNewNumber == '' || item.goodsBatchNewNumber == null;
        const productionEmpty = item.goodsProductionNewDate == undefined || item.goodsProductionNewDate == '' || item.goodsProductionNewDate == null;
        const expiryEmpty = item.goodsExpiryNewDate == undefined || item.goodsExpiryNewDate == '' || item.goodsExpiryNewDate == null;
        if (numberEmpty && productionEmpty && expiryEmpty) {
          canPass = false;
        }
        list.push(tempModel);
      });
      if (!canPass) {
        this.$Message.error('请输入订正内容');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          toolsService.dateRevisalSubmit({ inventoryInfoList: list }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.$router.push({ name: 'informationRevisal' });
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    handlePageChange(page) {
      this.queryParams.page = page;
      this.getOrders();
    },
    handleSizeChange(size) {
      this.queryParams.size = size;
      this.getOrders();
    },
    getOrders() {
      const params = utils.deepClone(this.queryParams);
      this.resultList = [];
      toolsService.dateRevisalSearch(params).then((res) => {
        if (res.data.status === 200) {
          this.queryParams.count = res.data.data.count;
          this.resultList = res.data.data.list.map((item) => {
            item._checked = this.tempList.filter(beforeItem => beforeItem.id == item.id).length > 0 && this.formData.tableData.filter(beforeItem => beforeItem.id == item.id).length <= 0;
            item._disabled = this.formData.tableData.filter(beforeItem => beforeItem.id == item.id).length > 0;
            if (item._disabled) {
                item._checked = true;
            }
            return item;
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // modal关闭
    modalCancel() {
      this.tempList = utils.deepClone(this.formData.tableData);
      this.resultList = [];
    },
  },
  mounted() {
  },
};

</script>
  <style lang="less" >
  .PaymentOrders .noEqual{
    color: #FF4D07
  }
  .queryParams{
    display:flex;
    flex-shrink: 1;
    >div{
      width: 300px;
    display:flex;
    align-items: center;
    }
  }
  </style>
